import { ActionLink } from "./ActionLink";

const FOOTER_I18N = {
  fr: {
    contactText: "Contactez-nous",
    contactUrl:
      "https://www.imajing.eu/contact-us/?utm_source=imajnet.net&utm_medium=referral&utm_campaign=fr_contact",
    techText: "En savoir plus sur les technologies Imajing",
    techUrl:
      "https://imajing.eu/fr/technologies-cartographie-mobile/?utm_source=imajnet.net&utm_medium=referral&utm_campaign=fr_technologies_footer",
    logoUrl:
      "https://imajing.eu/fr/technologies-cartographie-mobile/?utm_source=imajnet.net&utm_medium=referral&utm_campaign=fr_footer_logo_technologies",
    logoAlt: "Imajing",
    logoLabel: "Technologies Imajing",
  },
  en: {
    contactText: "Contact us",
    contactUrl:
      "https://www.imajing.eu/contact-us/?utm_source=imajnet.net&utm_medium=referral&utm_campaign=en_contact",
    techText: "Learn more about Imajing technologies",
    techUrl:
      "https://imajing.eu/mobile-mapping-technologies/?utm_source=imajnet.net&utm_medium=referral&utm_campaign=en_technologies_footer",
    logoUrl:
      "https://imajing.eu/mobile-mapping-technologies/?utm_source=imajnet.net&utm_medium=referral&utm_campaign=en_footer_logo_technologies",
    logoAlt: "Imajing",
    logoLabel: "Imajing technologies",
  },
  es: {
    contactText: "Contactar con Imajing",
    contactUrl:
      "https://www.imajing.eu/contact-us/?utm_source=imajnet.net&utm_medium=referral&utm_campaign=es_contact",
    techText: "Más información sobre las tecnologías Imajing",
    techUrl:
      "https://imajing.eu/es/tecnologias-cartografia-movil/?utm_source=imajnet.net&utm_medium=referral&utm_campaign=es_technologies_footer",
    logoUrl:
      "https://imajing.eu/es/tecnologias-cartografia-movil/?utm_source=imajnet.net&utm_medium=referral&utm_campaign=es_footer_logo_technologies",
    logoAlt: "Imajing",
    logoLabel: "Tecnologías Imajing",
  },
};

export function SiteFooter({ copy, locale = "en" }) {
  const t = FOOTER_I18N[locale] || FOOTER_I18N.en;
  return (
    <footer className="site-footer">
      <a
        className="footer-brand"
        href={t.logoUrl}
        rel="noopener noreferrer"
        target="_blank"
        aria-label={t.logoLabel}
        title={t.logoLabel}
      >
        <img src="/media/imajing-logo.png" alt={t.logoAlt} />
      </a>
      <ActionLink href={t.contactUrl}>{t.contactText}</ActionLink>
      <a
        className="button"
        href={t.techUrl}
        rel="noopener noreferrer"
        target="_blank"
        aria-label={t.techText}
        title={t.techText}
      >
        {t.techText}
      </a>
      <div className="social-links">
        <a href="https://www.linkedin.com/company/imajing-s-a-s" rel="noreferrer" target="_blank">
          LinkedIn
        </a>
        <a href="https://www.youtube.com/user/Imajbox" rel="noreferrer" target="_blank">
          YouTube
        </a>
      </div>
      <div>&copy; {new Date().getFullYear()} {copy.copyright}</div>
    </footer>
  );
}
